import { render, staticRenderFns } from "./VOverlayIntro.vue?vue&type=template&id=63d655a4"
import script from "./VOverlayIntro.vue?vue&type=script&lang=js"
export * from "./VOverlayIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports